module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//game-modal_battle.png?v=ab38ea5c";